// app/javascript/dashboard/mixins/kanban/dynamicHeights.js
export default {
    data() {
      return {
        _cardsLists: [],
        _resizeObserver: null,
        _mutationObserver: null,
        _onWindowResize: null,
      };
    },
    methods: {
      registerCardsList(vmOrEl) {
        const el = vmOrEl?.$el || vmOrEl;
        if (el && !this._cardsLists.includes(el)) {
          this._cardsLists.push(el);
          this.deferUpdateHeights();
        }
      },
      initDynamicHeights() {
        this._onWindowResize = () => {
          requestAnimationFrame(() => this.updateCardsScrollerHeights());
        };
        window.addEventListener('resize', this._onWindowResize);

        const root = document.querySelector('#app') || document.body;
        try {
          this._resizeObserver = new ResizeObserver(() => {
            requestAnimationFrame(() => this.updateCardsScrollerHeights());
          });
          this._resizeObserver.observe(root);
        } catch {
          // segue apenas com o resize
        }
        this.updateCardsScrollerHeights();
      },
      initMutationObserver() {
        if (!this.$refs.kanbanWrap || !window.MutationObserver) return;
        this._mutationObserver = new MutationObserver(() => {
          this.deferUpdateHeights();
        });
        this._mutationObserver.observe(this.$refs.kanbanWrap, {
          childList: true,
          subtree: true,
        });
      },
      deferUpdateHeights() {
        requestAnimationFrame(() => {
          this.updateCardsScrollerHeights();
          setTimeout(this.updateCardsScrollerHeights, 0);
        });
      },
      updateCardsScrollerHeights() {
        if (!this._cardsLists.length) return;
        const viewportH =
          window.innerHeight || document.documentElement.clientHeight || 800;
        const bottomPadding = 24;
        const minH = 220;

        this._cardsLists.forEach(listEl => {
          if (!listEl || !listEl.getBoundingClientRect) return;
          const rect = listEl.getBoundingClientRect();
          let available = Math.floor(viewportH - rect.top - bottomPadding);
          if (!Number.isFinite(available)) available = minH;
          if (available < minH) available = minH;
          listEl.style.height = `${available}px`;
          listEl.style.maxHeight = `${available}px`;
          listEl.classList.add('force-scrollbar');
        });
      },
      _teardownDynamicHeights() {
        if (this._resizeObserver) {
          try { this._resizeObserver.disconnect(); } catch {}
          this._resizeObserver = null;
        }
        if (this._mutationObserver) {
          try { this._mutationObserver.disconnect(); } catch {}
          this._mutationObserver = null;
        }
        if (this._onWindowResize) {
          window.removeEventListener('resize', this._onWindowResize);
          this._onWindowResize = null;
        }
      },
    },
    beforeUnmount() {
      this._teardownDynamicHeights();
    },
  };
